import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div`
  width: 236px;
  background-color: #e8fdec;
  border: 1px #93d09f dashed;
  height: 42px;
  border-radius: 2px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  > p {
    font-size: 10px;
    line-height: 12px;
  }
  @media ${device.mobileS} {
    width: 100%;
  }
`;

export const CloseIcon = styled.span`
  width: 15px;
  height: 15px;
  position: absolute;
  right: 5px;
  top: 1px;
  cursor: pointer;
  img {
    width: 15px;
  }
`;
